import { render, staticRenderFns } from "./integralrecord.vue?vue&type=template&id=0a4bf654&scoped=true"
import script from "./integralrecord.vue?vue&type=script&lang=js"
export * from "./integralrecord.vue?vue&type=script&lang=js"
import style0 from "./integralrecord.vue?vue&type=style&index=0&id=0a4bf654&prod&lang=scss&scoped=true"
import style1 from "./integralrecord.vue?vue&type=style&index=1&id=0a4bf654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bf654",
  null
  
)

export default component.exports